import { render } from "./AtlastiLogo.vue.js?vue&type=template&id=219744b2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./AtlastiLogo.vue?vue&type=template&id=219744b2"
const script = {}

import "./AtlastiLogo.vue.scss?vue&type=style&index=0&id=219744b2&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./AtlastiLogo.vue?vue&type=style&index=0&id=219744b2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__